import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  introSection,
  definitionsSection,
  intersectionalitySection,
} from '../data/aboutContent';

const AboutPsychotherapy = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F3EB]">
      {/* Hero */}
      <section className="relative pt-32 pb-16 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[#F5F3EB] -z-10"></div>
        <div className="max-w-4xl mx-auto text-center">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <Link
              to="/qui-suis-je"
              className="inline-flex items-center text-sm font-medium text-[#4A4458] hover:text-[#21167D] transition-colors mb-6"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à « Qui suis-je ? »
            </Link>
            <h1 className="font-display text-4xl md:text-5xl font-semibold text-[#21167D] mb-6">
              Mais c'est quoi la psychothérapie ?
            </h1>
          </div>
        </div>
      </section>

      {/* Section B — Avant toute chose */}
      <section className="py-16 px-4 bg-[#FDFBF5]">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-6">
              {introSection.heading}
            </h2>
            <p className="text-lg text-[#4A4458] leading-relaxed">{introSection.text}</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl border-4 border-[#F5F3EB]">
            <img
              src={introSection.image.src}
              alt={introSection.image.alt}
              loading="lazy"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* Section C — Définitions */}
      <section className="py-16 px-4 bg-[#DCB071]/10">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-6">
            {definitionsSection.heading}
          </h2>
          <div className="space-y-5 text-lg text-[#4A4458] leading-relaxed">
            {definitionsSection.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </section>

      {/* Section D — Intersectionnalité */}
      <section className="py-16 px-4 bg-[#FDFBF5]">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 rounded-2xl overflow-hidden shadow-xl border-4 border-[#F5F3EB]">
            <img
              src={intersectionalitySection.image.src}
              alt={intersectionalitySection.image.alt}
              loading="lazy"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-6">
              {intersectionalitySection.heading}
            </h2>
            <div className="space-y-5 text-lg text-[#4A4458] leading-relaxed">
              {intersectionalitySection.paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-[#21167D]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl font-semibold text-[#F5F3EB] mb-6">
            Envie d'en savoir plus sur mon approche ?
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/mon-approche">
              <Button size="lg" className="bg-[#EAA93D] text-[#21167D] hover:bg-[#F5F3EB] hover:text-[#21167D] shadow-xl">
                Découvrir mon approche
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/rendez-vous">
              <Button size="lg" variant="outline" className="border-[#F5F3EB] text-[#F5F3EB] hover:bg-[#F5F3EB] hover:text-[#21167D]">
                Prendre rendez-vous
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPsychotherapy;
